import type { SupabaseClient } from '@supabase/supabase-js';

/** Positive, default-OFF organisation opt-in; global rows never enable this feature. */
export const QI_IMPROVEMENTS_V1_FLAG = 'qi_improvements_v1';
export const QI_IMPROVEMENTS_DISABLED =
  'These additional QI tools are unavailable for your organisation. Continue existing reporting in Compliance > Quality indicators > Quarter. Ask your organisation administrator to contact Statura support about access.';

/** Same exact-tenant feature_flags pattern as roster app events; no env or new schema. */
export async function loadQiImprovementsEnabled(
  sb: SupabaseClient,
  tenantId?: string | null,
): Promise<boolean> {
  if (!tenantId?.trim()) return false;
  try {
    const { data, error } = await sb
      .from('feature_flags')
      .select('enabled')
      .eq('tenant_id', tenantId.trim().toLowerCase())
      .eq('flag_key', QI_IMPROVEMENTS_V1_FLAG)
      .maybeSingle();
    return !error && data?.enabled === true;
  } catch {
    return false;
  }
}
